import { Card as HeroCard, cn } from '@heroui/react'
import { type ReactNode } from 'react'

/** A row of scorecards. The hero spans two columns and comes first. */
export const Tiles = ({ children }: { children: ReactNode }) => (
  <div className="grid grid-cols-[repeat(auto-fit,minmax(150px,1fr))] gap-3">
    {children}
  </div>
)

type TileProps = {
  label: string
  value: string
  hero?: boolean
  /** Reserved period-on-period slot; rendered empty so adding it reflows nothing. */
  delta?: string
}

/**
 * A scorecard: value first, the comparison band, then the label. Nothing else —
 * anything that needs saying goes in the block's info toggle.
 */
const Tile = ({ label, value, hero = false, delta = '' }: TileProps) => (
  <HeroCard
    className={cn(
      'grid gap-1 rounded-xl p-4',
      hero && 'bg-surface-secondary col-span-2'
    )}
  >
    <div
      className={cn(
        'font-semibold tracking-tight tabular-nums',
        hero ? 'text-3xl' : 'text-2xl'
      )}
    >
      {value}
    </div>
    <div className="text-muted min-h-[1.2em] text-xs">{delta}</div>
    <div className="text-muted text-sm">{label}</div>
  </HeroCard>
)

export default Tile
